import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-home-benefits',
    standalone: true,
    imports: [CommonModule,TranslateModule,RouterModule],
    templateUrl: './home-benefits.component.html',
})
export class HomeBenefitsComponent {}
